module.exports = __webpack_public_path__ + "img/menuboard_thai_express.b433f91e.jpg";